


































import { Component, Prop, Vue } from 'vue-property-decorator';

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

export type DropzoneVariant = 'default' | 'block';

@Component({})
export default class Dropzone extends Vue {
  @Prop({ default: true }) hasChooseImage!: boolean;
  @Prop({ default: 'image/*' }) accept!: string;
  @Prop({ default: false }) hasError?: boolean;
  @Prop({ default: 'default' }) variant?: DropzoneVariant;
  @Prop({ default: false }) disabled?: boolean;
  @Prop() instanceId?: string;

  isHover = false;
  isDragging = false;

  onInput(event: HTMLInputEvent) {
    const files = event.target.files || [];

    this.$emit('input', Array.from(files));
  }

  onDragover(event: DragEvent) {
    this.isDragging = true;
  }

  onDragleave(event: DragEvent) {
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    this.isDragging = false;

    if (this.disabled) {
      return;
    }

    if (event.dataTransfer) {
      const files = [...event.dataTransfer.files] as Array<File>;

      this.$emit('input', files);
    }
  }

  handleMouseEnter() {
    this.isHover = true;
  }

  handleMouseLeave() {
    this.isHover = false;
  }
}
